import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const buildQueryParams = (params) => {
  return Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
};

const fetchBenchmarkSummary = async ({ queryKey }) => {
  const [, testSuiteResultId] = queryKey;

  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetails);

  const queryParams = buildQueryParams({
    action: "getBenchmarkSummary",
    companyid: user.companyid,
    testsuiteresultid: testSuiteResultId,
  });

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryParams}`
  );

  return response.data;
};

const useBenchmarkSummaryQuery = (testSuiteResultId, options = {}) => {
  return useQuery({
    queryKey: ["benchmarkSummary", testSuiteResultId],
    queryFn: fetchBenchmarkSummary,
    enabled: Boolean(testSuiteResultId),
    staleTime: 1000 * 60 * 5,
    ...options,
  });
};

export default useBenchmarkSummaryQuery;